var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-row"},[_c('b',[_vm._v(_vm._s(_vm.tag)+":")]),_vm._v(" "+_vm._s(_vm.value)+" "+_vm._s(_vm.unit)),_c('br')])
}
var staticRenderFns = []

export { render, staticRenderFns }